import type { UseFetchOptions } from 'nuxt/app'
import type { ComputedRef } from 'vue'
import type { StrapiApiDefaultResponse } from '~/composables/types/strapi-api'
import type { StrapiMagazineArticleCategory } from '~/composables/types/strapi/strapi-magazine'

export function useStrapiArticleCategories({
  slug = ref(undefined),
  options = {},
  query,
  locale: customLocale,
}: {
  slug?:
    | Ref<string | undefined>
    | ComputedRef<string | undefined>
    | string
    | undefined
  options?: UseFetchOptions<
    StrapiApiDefaultResponse<StrapiMagazineArticleCategory[]>,
    StrapiMagazineArticleCategory[]
  >
  query?: Record<string, string>
  locale?: string
} = {}) {
  const { locale } = useI18n()

  const articlesUrl = new URLSearchParams()

  articlesUrl.set('sort', 'createdAt:desc')

  if (toValue(slug)) {
    articlesUrl.set('filters[slug][$eq]', toValue(slug))
  }

  if (query) {
    Object.keys(query).forEach((key) => {
      articlesUrl.set(key, query[key])
    })
  }

  articlesUrl.set('locale', customLocale || locale.value)

  return useStrapi<StrapiMagazineArticleCategory>({
    urlSuffix: 'categories?' + articlesUrl.toString(),
    options,
    lazy: true,
  })
}
